"use client";

import { ResourceContext } from "@/contexts/resource-context";
import { clientPost } from "@/service/client-api/client-api";
import { useContext } from "react";
import { logEvent } from "@/service/logs/log";
import { Button, ButtonVariant } from "@/components/ui/button";
import { LockKeyholeOpenIcon } from "lucide-react";
import { useRouter } from "@bprogress/next";
import { toast } from "sonner";

export const FreebieButton = ({
  product,
  variant = "secondary",
}: {
  product: ProductPriceOneVariantVM;
  text?: string;
  theme?: string;
  variant?: ButtonVariant;
}) => {
  const router = useRouter();
  const { logView } = useContext(ResourceContext);
  const { price, id } = product;

  async function onClick() {
    if (parseFloat(price) !== 0) return;
    try {
      logEvent("get_freebie", logView, { productVariantId: id });

      await clientPost("freebie.activate", { productVariantId: id });
      toast.success("Kurs został aktywowany");
      router.refresh();
    } catch (error) {
      toast.error(
        (error as ServerError)?.error ?? "Nie udało się aktywować kursu.",
      );
    }
  }
  return (
    <Button onClick={onClick} variant={variant} className="w-full">
      <LockKeyholeOpenIcon /> Odblokuj bezpłatnie
    </Button>
  );
};
